import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const releaseSaleList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/place/placeList?` + params,
        method: 'GET'
    })
}
export const findProducts = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/place/goodsList`,
        method: 'GET'
    })
}
export const findLabelList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
        method: 'GET'
    })
}
export const findPlaceDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/place/placeDetail/${id}`,
        method: 'GET'
    })
}
export const editReleaseSale = (params) => {
    return request({
        url: `${baseUrl}/joins-product/v1/place/updatePlace`,
        method: 'PUT',
        data: params
    })
}
export const cancelPlaceSale = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/place/cancelPlace/${id}`,
        method: 'GET',
    })
}

export const addSales = (params) => {
    return request({
        url: `${baseUrl}/joins-product/v1/place/insertPlace`,
        method: 'POST',
        data: params
    })
}

